// src/components/integrador/resumen_libros/components/HeroHeader.jsx
import React from "react";
import { Box, Container, Typography } from "@mui/material";

const HeroHeader = ({ img, title, subtitle, description, maxWidth = "xxl" }) => {
    return (
    <Box sx={{ width: "100%" }}>
      <Container
        maxWidth={maxWidth}
        sx={{
          p:0
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center", 
            gap: { xs: 1.5, md: 2.5 },
          }}
        >
          {img && (
            <Box
              component="img"
              src={img}
              alt="Hero"
              sx={{
                width: "clamp(80px, 4vw, 110px)",
                height: "auto",
                objectFit: "contain",
                flexShrink: 0,
                mt: { xs: 0.2, md: 0.4 }, 
              }}
            />
          )}

          <Box sx={{ minWidth: 0, pt: { xs: 0.3, md: 0.6 } }}>
            {/* SUBTITLE ARRIBA */}
            {subtitle ? (
              <Typography
                sx={{
                  fontSize: 12,
                  fontWeight: 800,
                  letterSpacing: "0.22em",
                  textTransform: "uppercase",
                  color: "#82868c",
                  mb: 0.6,
                  lineHeight: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={subtitle}
              >
                {subtitle}
              </Typography>
            ) : null}

            {/* TITLE DEBAJO */}
            <Typography
              sx={{
                fontSize: { xs: 34, md: 40, xl:54 },
                fontWeight: 900,
                color: "#82868c", 
                lineHeight: 1.02,
                letterSpacing: "-0.02em",
              }}
            >
              {title}
            </Typography>

            {/* DESCRIPCIÓN debajo del título */}
            {description ? (
              <Typography
                sx={{
                  mt: 1,
                  fontSize: { xs: 13, md: 14 },
                  fontWeight: 600,
                  color: "#82868c", 
                  lineHeight: 1.5,
                  maxWidth: { xs: "100%" },
                }}
              >
                {description}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroHeader;
